/**
 * @generated SignedSource<<dfa9a648c773c1a9d80d28727edeaf85>>
 * @relayHash 4ac3b2d2bb89755b2c333495007a3a3c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26db25eda3e1fb7e3dfa4833a61d78b1caae21e12b50dd1529f6cb4ea61973ac

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPresentationsScreenQuery$variables = {
  id: string;
};
export type UserPresentationsScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "User";
    readonly firstName: string;
    readonly lastName: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserMetadata_user" | "UserPresentationsScreenOtherPresentationsSection_user" | "UserPresentationsScreenUpcomingPresentationsSection_user">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type UserPresentationsScreenQuery = {
  response: UserPresentationsScreenQuery$data;
  variables: UserPresentationsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v7 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_DESC",
    "ID_ASC"
  ]
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "UPCOMING"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v11 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v12 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v13 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PresentationsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Presentation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prettyUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoSourceUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "presenterFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "presenterLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "presenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailMd5",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          (v10/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fit",
                            "value": "cover"
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "transform"
                  }
                ],
                "kind": "ScalarField",
                "name": "defaultAvatarUrl",
                "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "transform",
                "value": {
                  "dpr": 3,
                  "fo": "auto",
                  "h": 32,
                  "w": 32
                }
              }
            ],
            "kind": "ScalarField",
            "name": "guestPresenterAvatarUrl",
            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":32,\"w\":32})"
          },
          (v5/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v15 = [
  "timeSelection",
  "orderBy"
],
v16 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "OTHER"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPresentationsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserMetadata_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserPresentationsScreenUpcomingPresentationsSection_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserPresentationsScreenOtherPresentationsSection_user"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserPresentationsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "upcomingPresentations",
                "args": (v8/*: any*/),
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "upcomingPresentations",
                "args": (v8/*: any*/),
                "filters": (v15/*: any*/),
                "handle": "connection",
                "key": "UserPresentationsScreenUpcomingPresentationsSection_user_upcomingPresentations",
                "kind": "LinkedHandle",
                "name": "presentations"
              },
              (v5/*: any*/),
              {
                "alias": "otherPresentations",
                "args": (v16/*: any*/),
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"OTHER\")"
              },
              {
                "alias": "otherPresentations",
                "args": (v16/*: any*/),
                "filters": (v15/*: any*/),
                "handle": "connection",
                "key": "UserPresentationsScreenOtherPresentationsSection_user_otherPresentations",
                "kind": "LinkedHandle",
                "name": "presentations"
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "26db25eda3e1fb7e3dfa4833a61d78b1caae21e12b50dd1529f6cb4ea61973ac",
    "metadata": {},
    "name": "UserPresentationsScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0141c3f2c29505340268c3daaa1b1fba";

export default node;
